// extracted by mini-css-extract-plugin
module.exports = {"countBtnWrap":"SelectCountBtn_countBtnWrap__3JzWK","minusBtn":"SelectCountBtn_minusBtn__3ZXwt","plusBtn":"SelectCountBtn_plusBtn__3Wl14","value":"SelectCountBtn_value__3tJgq"};